import React from 'react';
import { useHistory } from 'react-router-dom';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IconButton } from '@material-ui/core';

interface BackArrowButton {
    onClick?: () => void;
    size?: 'small' | 'medium';
    color?: 'inherit' | 'primary' | 'secondary' | 'default';
}

export default function BackArrow({
    onClick,
    size = 'medium',
    color = 'inherit',
}: BackArrowButton) {
    const history = useHistory();

    const action = onClick ? onClick : () => history.goBack();
    return (
        <IconButton
            aria-label="delete"
            size={size}
            //className={classes.iconButton}
            onClick={action}
            color={color}
        >
            <ArrowBackIcon fontSize="inherit" />
        </IconButton>
    );
}
